import { StoreAction } from "../../../types/store"
import { Player } from "../lib/player"

export type SetPlayerAction = StoreAction & { player: Player }
export const SET_PLAYER = "SET_PLAYER"
export const setPlayer = (player: Player): SetPlayerAction => ({
  type: SET_PLAYER,
  player,
})
